module.exports = __webpack_public_path__ + "img/my-groups.3ef01958.svg";